import apiClient from './client'

import type { PDI, PDIInput, PaginatedResponse } from '@/types/gia'

interface PDIFilters {
  page?: number
  centro?: number
  es_trabajador?: boolean
  activo?: boolean
}

const pdisApi = {
  list: async (filters: PDIFilters = {}): Promise<PaginatedResponse<PDI>> => {
    const response = await apiClient.get<PaginatedResponse<PDI>>('/pdis/', {
      params: filters
    })

    return response.data
  },

  listAll: async (filters: Omit<PDIFilters, 'page'> = {}): Promise<PDI[]> => {
    const items: PDI[] = []
    let page = 1
    let hasMore = true

    while (hasMore) {
      const response = await apiClient.get<PaginatedResponse<PDI>>('/pdis/', {
        params: { ...filters, page }
      })

      items.push(...response.data.results)
      hasMore = response.data.next !== null
      page += 1
    }

    return items
  },

  create: async (data: PDIInput): Promise<PDI> => {
    const response = await apiClient.post<PDI>('/pdis/', data)

    return response.data
  },

  update: async (id: number, data: Partial<PDIInput>): Promise<PDI> => {
    const response = await apiClient.put<PDI>(`/pdis/${id}/`, data)

    return response.data
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/pdis/${id}/`)
  },

  toggleActive: async (id: number): Promise<PDI> => {
    const response = await apiClient.post<PDI>(`/pdis/${id}/toggle_active/`)

    return response.data
  }
}

export default pdisApi
